<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <div class="row">
          <h3 class="col-8" style="margin-left: -16px;">
            {{ shipmentEstimation.reference_code }}
          </h3>
          <div class="col-4 text-right">
            <base-button
              v-if="shipmentEstimation.status=='CREATED'"
              type="button"
              @click="openPickupForm(shipmentEstimation)"
              class="elite-button add text-right"
            >
              <span class="btn-inner--icon">
                <i class="far fa-truck"></i>
              </span>
              <span class="btn-inner--text">
                Pickup
              </span>
            </base-button>

            <div class="row" v-if="shipmentEstimation.status=='PENDING'">
              <div class="col-6">
                <base-button
                  
                  type="button"
                  @click="approveEstimation(shipmentEstimation)"
                  class="elite-button add text-right"
                >
                  <span class="btn-inner--text">
                    Approuver
                  </span>
                </base-button>
              </div>
              <div class="col-6">
                <base-button
                type="button"
                @click="cancelEstimation(shipmentEstimation)"
                class="elite-button danger text-right"
              >
                <span class="btn-inner--text">
                  Annuler
                </span>
              </base-button>
              </div>
            </div>
            
            
          </div>
        </div>
    </div>
    <div class="row">
      <div class="col-9">

        <dl
          class="row"
        >
          <dt class="col-sm-4">{{ $t("COMMON.STATUS") }}</dt>
          <dd class="col-sm-8">
            <estimation-status-badge-component :estimation="shipmentEstimation" />
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("SHIPMENTS.TOTAL") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(shipmentEstimation.total) }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("SHIPMENTS.ITEMS_COUNT") }}</dt>
          <dd class="col-sm-8">
            {{ shipmentEstimation.shipments.length }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_BY") }}</dt>
          <dd class="col-sm-8">
            <users :users="[shipmentEstimation.createdBy]" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_BY") }}</dt>
          <dd class="col-sm-8">
            <users :users="[shipmentEstimation.updatedBy]" />
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8" v-if="shipmentEstimation.created_at">
            {{ $formatDate(shipmentEstimation.created_at) }}
          </dd>
        </dl>
        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8" v-if="shipmentEstimation.updated_at">
            {{ $formatDate(shipmentEstimation.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
    <modal
      :show="showPickupForm"
      modal-classes="modal-secondary"
      size="lg"
      @close="showPickupForm = false"
    >
      <!-- HEADER -->
      <!--<div class="content-btns-modal">
        <div class="modal-header">
          <button
            type="button"
            class="btn btn-link ml-auto"
            @click="showPickupForm=false;"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>-->
      <span class="resize-loading" v-if="Object.keys(pickupDefaults).length == 0">
        <span class="loader"></span>
      </span>
      <!-- BODY -->
      <div class="pickup-form-wrapper">
        <pickup-form
          v-if="Object.keys(pickupDefaults).length > 0"
          :groupId="currentGroupId"
          :initial-details="pickupDefaults"
          @cancel="showPickupForm = false"
          @pickupCreated="onPickupSubmitted"
        />
      </div>

    </modal>
  </div>
</template>

<script>

import swal from "sweetalert2";
import Users from "@/components/Users.vue";
import EstimationStatusBadgeComponent from "@/components/EstimationStatusBadgeComponent";
import PickupForm from "@/components/Shipment/PickupForm.vue";
import {
  PICKUP_LOCATIONS,
} from "@/components/ElixioConnect/constants/shipment";
export default {
  name: "shipment-estimation-view-global",

  components: {
    Users,
    EstimationStatusBadgeComponent,
    PickupForm,
  },

  props: ["shipmentEstimation"],

  data() {
    return {
      pickupDefaults: {},
      pickupLocations: PICKUP_LOCATIONS,
      showPickupForm: false,
      currentGroupId: "",
      packageDetails: {
        weight : {
            unit: 'kg',
            value: '1',
        },
        packages:[
          {
              depth: '1',
              width: '13',
              length: '20',
              weight: '1',
              quantity: '1',
          }
        ]
      },
    };
  },

  computed: {},

  created() {},

  methods: {
    createPickupPackage(estimation) {
      this.packageDetails.packages.quantity = estimation.shipments.length;
      const packages = this.packageDetails.packages || [];
      const totalWeight = packages.reduce(
        (sum, p) => sum + Number(p.weight || 0) * Number(estimation.shipments.length),
        0
      );
      const totalQuantity = packages.reduce(
        (sum, p) => sum + Number(estimation.shipments.length),
        0
      );

      this.pickupDefaults = {
        pickup_details: {
          date: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate(),
          },
          ready_at: { hour: 9, minute: 0 },
          ready_until: { hour: 17, minute: 0 },
          package_details: {
            weight: {
              unit: this.packageDetails.weight.unit,
              value: totalWeight.toString(),
            },
            quantity: totalQuantity.toString(),
          },
          pickup_location: this.pickupLocations,
          pickup_instructions: "",
        }
      };
    },
    openPickupForm(estimation) {
      this.currentGroupId = estimation.id;
      this.createPickupPackage(estimation);
      this.showPickupForm = true;
    },
    async onPickupSubmitted() {
      this.showPickupForm = false;
      this.$emit("onPickupCreated", this.shipmentEstimation, true);
    },
    closePickupModal(){
      this.showPickupForm = false;
    },
    async approveEstimation(estimation) {
      const confirmation = await swal.fire({
        title: this.$t("SHIPMENTS.APPROVE_THIS_ESTIMATION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        this.$store.dispatch("properties/createShippingSavedLetters", {group_id: estimation.id});
        swal.close();
        this.$notify({
          type: "success",
          message: this.$t("SHIPMENTS.SHIPMENT_TO_CREATE"),
        });
        /*if (confirmation.value === true) {
            const response = await this.$store.dispatch("properties/createShippingSavedLetters", {estimations : estimation.shippments, group_id: estimation.id});
            //this.getList('PENDING');
            this.$emit("onShipmentCreated", true);
            this.$notify({
                type: "success",
                message: this.$t("PROPERTIES.SHIPPMENT_CREATED"),
            });
        }*/
      } catch (error) {
        //await this.showRequestError(error);
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.  $t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    async cancelEstimation(estimation) {
      this.showPickupForm = false;
      this.$emit("onCancelEstimation", estimation, true);
    },
  },

  mounted() {},

  watch: {
    shipmentEstimation(shipmentEstimation) {},
  },
};
</script>
